(() => {
  const banner = document.querySelector('[data-consent-banner]');
  const dialog = document.querySelector('[data-consent-dialog]');
  if (!banner || !dialog) return;
  let privacy, trigger, ready = false;
  const error = dialog.querySelector('[data-consent-error]');
  const checked = () => Object.fromEntries(['analytics','marketing','preferences'].map(key => [key,dialog.querySelector(`[name="${key}"]`).checked]));
  const fill = () => { const current = privacy?.currentVisitorConsent() || {}; for (const key of ['analytics','marketing','preferences']) dialog.querySelector(`[name="${key}"]`).checked = current[key] === 'yes'; };
  function open(event) { trigger = event.currentTarget; fill(); error.hidden = ready; if (!ready) error.textContent = error.dataset.message; dialog.showModal(); }
  function save(value) {
    if (!ready) { if (!dialog.open) dialog.showModal(); error.hidden = false; error.textContent = error.dataset.message; return; }
    const buttons = document.querySelectorAll('[data-consent-accept],[data-consent-reject],[data-consent-save]');
    for (const button of buttons) button.disabled = true;
    let completed = false;
    const timer = setTimeout(() => finish({ error: true }), 10000);
    function finish(result) {
      if (completed) return; completed = true; clearTimeout(timer);
      for (const button of buttons) button.disabled = false;
      if (result?.error) { error.textContent = error.dataset.message; error.hidden = false; if (!dialog.open) dialog.showModal(); return; }
      banner.hidden = true; error.hidden = true; dialog.close();
      window.dispatchEvent(new CustomEvent('proseed:consent', { detail: value }));
    }
    privacy.setTrackingConsent({ ...value, sale_of_data: false }, finish);
  }
  for (const button of document.querySelectorAll('[data-consent-open]')) button.addEventListener('click', open);
  for (const button of document.querySelectorAll('[data-consent-accept]')) button.addEventListener('click', () => save({analytics:true,marketing:true,preferences:true}));
  for (const button of document.querySelectorAll('[data-consent-reject]')) button.addEventListener('click', () => save({analytics:false,marketing:false,preferences:false}));
  dialog.querySelector('[data-consent-save]').addEventListener('click', () => save(checked()));
  dialog.querySelector('[data-consent-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => trigger?.focus());
  function loaded(failure) {
    if (failure) return;
    privacy = window.Shopify.customerPrivacy; ready = true;
    const consent = privacy.currentVisitorConsent();
    banner.hidden = ['analytics','marketing','preferences'].some(key => consent[key] === 'yes' || consent[key] === 'no');
    if (dialog.open) { fill(); error.hidden = true; }
  }
  if (window.Shopify?.customerPrivacy) loaded();
  else if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],loaded);
  else { banner.hidden = false; }
  document.addEventListener('visitorConsentCollected', () => { banner.hidden = true; if (dialog.open) fill(); });
})();
